import BaseContainer from "@base/container/BaseContainer";
import Utils from "@base/utils/Utils";
import ScaleManager from "@/stage/ScaleManager";
import gsap from "gsap";

export default class ParticlesAnimationContainer extends BaseContainer {
  constructor() {
    super()

    this.coinsCount = 12;
    this.coinsVersions = 3;

    this.name = "Particles Animation";
  }

  start({quantity = 100}) {
    this.coinsTotal = quantity;
    this.createCoins().placeCoins();
  }

  cleanup() {
    this.removeChildren();
    this.coins = null;
    this.visible = false;
  }

  createCoins() {
    this.visible = true;

    const v1 = this.generateCoinNames(1);
    const v2 = this.generateCoinNames(2);
    const v3 = this.generateCoinNames(3);

    this.coinNames = [...v1, ...v2, ...v3]
    const coins = [];
    for (let i = 0; i < this.coinsTotal; ++i) {
      const index = Utils.getRandomInt(0, this.coinsCount * this.coinsVersions - 1);
      const coinName = this.coinNames[index];
      const coin = new PIXI.Sprite(PIXI.Texture.from(coinName));
      coin.name = "Particles Coin";
      coin.index = i;
      coins.push(coin);
    }
    this.coins = coins;
    return this;
  }

  placeCoins() {
    let quantity = 0;
    let index = 0;

    const delayID = setInterval(() => {
      for (let i=0; i<20; ++i) {
        if (index >= this.coins.length) {
          index = 0;
        }

        if (quantity++ > this.coinsTotal) {
          clearInterval(delayID);
          break;
        }

        const nextCoin = this.coins[index++];
        nextCoin && this.playCoin(nextCoin);
      }
    }, 50);

    return this;
  }

  playCoin(coin) {
    this.addChild(coin);
    this.setRandomPosition(coin);
    coin.anchor.set(0.5);

    const center = ScaleManager.center.x;
    coin.alpha = 1;
    coin.y = ScaleManager.currentSizes.total.height - 400;
    gsap.to(coin, {
      duration: 1,
      y: Math.random() * ScaleManager.currentSizes.total.height / 2,
      x: Utils.getRandomInt(center - 900, center + 900),
      rotation: Utils.getRandomInt(0, 6.14 * 5),
      onUpdate: () => {
        // this.nextCoin(coin);
      },
      onComplete: () => {
        gsap.to(coin, {duration: 0.1, alpha: 0, onComplete: () => this.removeChild(coin)})
      }
    })
  }

  nextCoin(coin) {
    let index = ++coin.index;
    if (index >= this.coinsCount) {
      index = 0;
    }
    const coinName = this.coinNames[index];

    coin.texture = PIXI.Texture.from(coinName);
    coin.index = index;
  }

  setRandomPosition(object) {
    const totalWidth = ScaleManager.currentSizes.total.width / 2;
    object.x = Utils.getRandomInt(totalWidth - 200, totalWidth + 200);
  }

  generateCoinNames(version) {
    const result = [];
    for (let i = 0; i <= this.coinsCount; ++i) {
      const name = `${i}`.padStart(5, '0');
      const str = `bigWin/Gold_Coin/Coin_v${version}/gold_coin_v${version}_${name}`;
      result.push(str);
    }
    return result;
  }

}
